__turbopack_context__.v({
  "recent_card": "MoreQuestion-module-scss-module__VDJCEW__recent_card",
  "recent_card_more_button": "MoreQuestion-module-scss-module__VDJCEW__recent_card_more_button",
  "recent_card_more_button_text": "MoreQuestion-module-scss-module__VDJCEW__recent_card_more_button_text",
  "recent_card_text": "MoreQuestion-module-scss-module__VDJCEW__recent_card_text",
  "recent_cards": "MoreQuestion-module-scss-module__VDJCEW__recent_cards",
  "recent_cards_scroll_area": "MoreQuestion-module-scss-module__VDJCEW__recent_cards_scroll_area",
});
